<template>
  <div class="row">
    <edit-address ref="editAddress" v-on:updated="handleAddressUpdate"></edit-address>
    <div class="col-md-12">
      <alert
        :title="alert.title"
        :text="alert.text"
        :color="alert.style"
        :icon="alert.icon"
        :dismissable="true"
        v-on:dismiss="closeAlert"
      ></alert>

      <div v-if="!disableAddressEdit">
        <button type="button" class="btn btn-info" v-on:click="addAddress"><i class="fa fa-plus"></i> {{ $t('Addresses.add') }}</button>
      </div>
    </div>

    <div v-for="(address, aindex) in addresses" class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <addresscard
        :contact-id="address.ID"
        :type="address.type"
        :title="address.title"
        :firstname="address.firstname"
        :lastname="address.lastname"
        :address="address.address"
        :postalcode="address.postalcode"
        :city="address.city"
        :country="address.country"
        :is-shipping="address.isShipping"
        :is-billing="address.isBilling"
        :is-home="address.isHome"
        v-on:remove="removeAddress"
        v-on:edit="editAddress"
        v-on:select="selectAddress"
        :editable="!disableAddressEdit"
        :removable="!address.isHome && !disableAddressEdit"
        :selectable="isSelectable"
      ></addresscard>
    </div>
  </div>
</template>
<script>
import EditAddress from './EditAddress.vue';

var view = require('../view.js'),
    viewData = {
      filters: {
        offset: 0,
        limit: 20,
        count: 0,
        pages: 0,
        status: null
      },
      'masterdata': {
        'loader': ''
      },
      'alert': {
        'title': '',
        'text' : '',
        'style': '',
        'icon' : '',
      },
      addresses: []
    };

export default view(viewData, {
  components: {
    'EditAddress': EditAddress
  },
  computed: {
    projectId() {
      return this.$parent.viewIndex;
    },
    isSelectable() {
      return this.projectId ? true : false;
    },
    disableAddressEdit() {
      return this.$root.hasOwnProperty('disableAddressEdit') && (typeof this.$root.disableAddressEdit != 'undefined') && this.$root.disableAddressEdit;
    }
  },
  mounted() {
    this.$parent.viewTitle = this.$t('Addresses.title');

    if (this.projectId) {
      this.$parent.setPrevious('ProjectDetails', this.projectId, 'cart');
    }

    this.refresh();
  },
  methods: {
    refresh(offset) {
      if (offset != null)
        viewData.filters.offset = offset;

      this.$http.get(this.$root.url + 'address/', {params: viewData.filters}).then(function(res) {
          viewData.filters.count = res.data.result.count;
          viewData.filters.offset = res.data.result.offset;
          viewData.filters.limit = res.data.result.limit;
          viewData.filters.pages = res.data.result.pages;

          viewData.addresses = res.data.result.data;
        }.bind(this),
        function(res) {
          this.alert.title = this.$t('Addresses.errorLoad');
          this.alert.style = 'danger';
          this.alert.icon  = 'exclamation-circle';
          if (typeof res.body.error == 'string') {
            this.alert.text  = res.body.error;
          }
        }.bind(this));
    },
    removeAddress(contactId) {
      if (!window.confirm(this.$t('Addresses.confirmRemove'))) {
        return;
      }

      this.$http.delete(this.$root.url + 'address/' + contactId, {params: viewData.filters}).then(function(res) {
          console.log('DELETE', res);
          this.refresh();
        }.bind(this),
        function(res) {
          this.alert.title = this.$t('Addresses.errorRemove');
          this.alert.style = 'danger';
          this.alert.icon  = 'exclamation-circle';
          if (typeof res.body.error == 'string') {
            this.alert.text  = res.body.error;
          }
        }.bind(this));
    },
    editAddress(contactId, address) {
      this.$refs.editAddress.openDialog(contactId, address);
    },
    selectAddress(contactId, address) {
      this.$parent.openView('ProjectDetails', this.projectId, 'cart', {deliveryAddress: address});
    },
    addAddress() {
      this.$refs.editAddress.openDialog();
    },
    handleAddressUpdate() {
      this.refresh();
    },
    closeAlert() {
      this.alert.title = '';
      this.alert.text  = '';
      this.alert.style = '';
      this.alert.icon  = '';
    }
  }
});
</script>
